import { Solution } from "@/redux/sbcs/sbcsSlice";
import { SbcSolutionTag } from "@repo/shared/types";

/**
 * The pills an entry wears. Its tags say which pools found the squad; two of
 * them only hold as labels under a condition:
 * - Club x Market: the squad is a mix. When the club-plus-market pool lands
 *   on the club-only squad, the entry says Club Only alone.
 * - Cheapest: the squad has the lowest total value of the ones found. An
 *   accepted swap can take that away, or hand it back.
 */
export const shownSolutionTags = (
  solution: Solution | null | undefined,
  solutions: Solution[],
): SbcSolutionTag[] => {
  if (!solution) return [];
  const lowest = Math.min(...solutions.map((entry) => entry.cost));
  return solution.tags.filter((tag) => {
    if (tag === "both") return !solution.tags.includes("club");
    if (tag === "market") return solution.cost <= lowest;
    return true;
  });
};
